/* eslint-disable quotes */
// Húngaro
//339768
export const hungaro = {
  start: "Kezdeni",
  configurations: "Beállítások",
  ramdom: "Véletlenszerű lejátszás mód",
  vibration: "Rezgés :",
  startgame: "A játék kezdete",
  save: "Mentsd meg a",
  delete: "Törlés",
  update: "Frissítés",
  lets: "Játsszunk",
  permanentbuy: "Állandó beszerzések",
  signature: "Havi előfizetés",
  signatureano: "Éves előfizetés",
  small: "Itt használhatod a valódi neved... vagy egy becenevet... :)",
  text1: "Szerezzen prémium hozzáférést és garantálja az összes frissítést",
  text2: "Előfizetéssel bármikor hozzáférhet a prémium verzióhoz.",
  gender: "Gender",
  male: "Man  ",
  female: "Nő",
  ambos: "Mindkettő",
  fechar: "Bezárás",
  sexualorientation: "Szexuális irányultság",
  heterosexual: "Heteroszexuális",
  homosexual: "Homoszexuális",
  bisexual: "Bisexuális",
  chooseavatar: "Válassza ki az avatárját",
  Participants: "Résztvevők",
  participant: "Résztvevői regisztráció",
  name: "Név",
  choosecategory: "Kategóriák kiválasztása",
  categories: "Kategóriák",
  light: "Fény",
  preliminary: "Előkészületek",
  oral: "Szóbeli",
  anal: "Anális",
  hot: "Forró",
  extreme: "Extrém",
  vd: "Igazság ?",
  dare: "Kihívások ?",
  truth: "Igazság",
  time: "Idő",
  createMyChallenges: "Kihívások létrehozása",
  chosen: "Kiválasztott",
  text3: "Engedd, hogy a szeretet áramoljon benned!",
  text4: "Készülj fel az intenzív életre",
  close: "Zárja be a",
  sele: "Válasszon ki egy opciót",
  dev: "Kifejlesztette Dev12BR",
  game: "Játék",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "KÖVETKEZŐ",
  config1: "Miért érdemes megvásárolni a Prémium verziót ?",
  config2: "Exkluzív kategóriák és több mint 800 új kihívás",
  config3: "Nincsenek hirdetések",
  config4: "Válasszon avatarokat, hogy növelje",
  config5: "Hozzon létre saját kihívásokat ",
  config6: "Támogatod a játékfejlesztést",
  config7: "Miért van a játéknak költsége?",
  config8:
    "A játék fejlesztéséhez időre van szükséged! :) Így támogatod a játékot, segítesz nekünk, hogy mindig javítsuk és frissítsük a játékot..",
  config9: "Hozz létre saját kihívásokat",
  age: `Ez a játék csak felnőtteknek szól, ezért legalább 18 évesnek kell lenned. Az "Igen" kiválasztásával Ön elfogadja a felhasználási feltételeket és az adatvédelmi szabályzatot.. 

    Ez a játék pároknak való, ezért legalább egy partnerrel kell játszani. 
    
    Ez nem egy társkereső alkalmazás, hanem egy módja annak, hogy játsszon a partnereddel..
    `,
  config10: "Exkluzív kategóriák",
  config11: "+ 800 új kihívás",
  assessment:
    "Kérjük, értékelje az alkalmazással kapcsolatos megjegyzések hozzáadásával. Visszajelzéseitek nagyon fontosak számunkra, hogy a játékot a lehető legjobban tudjuk tartani.",
  agree: "Igen, elmúltam 18 éves",
  noAgree: "Alkalmazás bezárása",
  apoio1: "Támogassa a fejlesztést a prémium verzió előfizetésével :)",
  apoio2: "Ne felejtsd el értékelni az alkalmazást a boltban S2",
  apoio3: "Hozzáférés a Premium verzió összes exkluzív funkciójához",
  apoio4: "Szabaduljon meg ettől a bannertől - Vásárolja meg a prémium verziót",
  version: "Prémium verzió",
  version1: "Prémium verzió",
  alert1: "Felhasználók regisztrálása a játékhoz",
  alert2: "Regisztrálj még legalább egy felhasználót a játékhoz",
  alert3: "Válasszon ki legalább egy kategóriát",
  alert4: `🔥 Vannak partnerek nélküli résztvevők. Minden nemből legalább két résztvevő legyen 🔞. 
        
Példa: Két heteroszexuális vagy két homoszexuális..`,
  tituloAlert1: "⚠️ A játék hamarosan kezdődik 😜",
  tituloAlert2:
    "⚠️ Kár 😬, internet nélkül vagy 📶. Kapcsolja be az internetet a készüléken, és vásárolja meg az előfizetést, vagy a végleges csomagot. És légy boldog😘.",
  parser: "Nincs partner",
  premiumImages: "Légy Prémium és még több avatárhoz férhetsz hozzá",
  duvidas: "Kérdések vagy javaslatok - Fűszeres kihívások",
  description: "Helló, a kérdésem vagy javaslatom a következő :",
  texto99:
    "Ha bármilyen problémája, kérdése vagy javaslata van, kérjük, küldjön nekünk e-mailt az alábbi gombra kattintva. Várjuk a beszélgetést!",
  send: "Küldje el a ✉️",
  contact: "Kapcsolat",
  botaoApple: "Vásárlások visszaállítása",
  alertCompra: "Az Ön vásárlása visszaállításra kerül",
  NotPurchase: "Nincsenek vásárlásaid",
  notPurchase2:
    "Ez a link csak azoknak a felhasználóknak szól, akik már vásároltak korábban, és vissza akarják állítani egy új eszközre.",
  termOfPotitic: "Felhasználási feltételek és adatvédelmi irányelvek",
  alertDeuErrado: "Valami rosszul sült el :(",
  alertDeuErrado2: "Töltse ki az összes információt",
  alertNome: "A mező kitöltése: Név",
  options: "Opciók",
  optionsTitle: "Opciók",
  gradualGame: "Fokozatos játék",
  textoCaixa:
    "Ha aktiválja ezt a választást, a kihívások fokozatosan, azaz a legkönnyebbtől a legszélsőségesebbig terjednek az Ön választása szerint.",
  comoJogar: "Hogyan kell játszani? 🤔",
  avalie: "Értékelje",
  novaCategoria: "Kategóriáim",
  alterLanguage: "Nyelvváltás ?",
  textLanguage: "A nyelvváltáskor az alkalmazás újraindul",
  textLanguage1: "Nyelvváltás",
  cancel: "Cancel",
  languages: "Nyelvek",
  email: "@email",
  deletCat: "Kategória törlése",
  textDeletCat:
    "A kategória törlésével az ebben a kategóriában található kihívások törlődnek. Ezt követően a műveletet már nem lehet visszacsinálni.",
  deletDes: "Kihívás törlése",
  textDeletDes:
    "A kihívás törlése után ezt a műveletet már nem lehet visszacsinálni.",
  desafio: "Új kihívás regisztrálása",
  desafiotexto: "Kihívás",
  textoeditDesafio: "Ki képes erre?",
  textEmquem: "Kinek?",
  nome: "Név",
  inicio: "A játék elindítása",
  inicio2:
    "Ha megnyomja ezt a gombot, a játékos regisztrációs képernyőre kerül. 👥.",
  inicio3: "A játék hamarosan kezdődik 🎲",
  inicio4: "Következő",
  inicio5: "Beállítások",
  inicio6: `Beállítások, mint például:
  
- Progresszív kihívások
- A kihívások nyelvének megváltoztatása 
- Kihívások létrehozása 
- Támogató 
- Többek között.`,
  inicio7: "Vége",
  inicio8: `Legyen Prémium és kap hozzáférést a következőkhöz:

- 450 új kihívás 😎

- Kizárólagos karakterek 🦸♀️ 🧑🚒
  
- Hozzon létre saját kihívásokat 📝
  
- Tartsa a játékot frissítve ✅
  
- És még sok más 😍`,
  inicio9: "Segítség",
  inicio10: "Üdvözöljük a játékban Spicy Challenges 🌶",
  inicio11:
    "Nézze meg, milyen egyszerű a játék és a menükben való navigálás kevesebb mint 30 másodperc alatt. 😎.",
  inicio12: "Oktatóprogram megtekintése 👍🏼",
  inicio13: "Nem akarok 👎🏼",
  inicio14: `A játék indításához legalább (2) két játékost kell felvenned a játékba. 😀
              
A fent jelzett gomb megnyomásával 👆
  
Minden alkalommal, amikor új felhasználót adsz hozzá, nyomd meg ugyanazt a gombot.😘`,
  cadastrarCategory: "Regisztráció kategória",
  inicio15: "Új kategória létrehozása",
  inicio16:
    "1. lépés : Nyomja meg a képernyő alján található + jelű gombot. A gomb megnyomása után megjelenik egy ablak, amelyben megadhatja az új kategóriát.",
  inicio17: "2. lépés: Adja meg az új kategóriát, és kattintson a mentésre.",
  inicio18:
    "3. lépés: A kategória szerkesztéséhez vagy a kategórián belüli kihívások hozzáadásához kattintson rá.",
  inicio19:
    "4. lépés: A következő képernyőn a ⬆️ nyíllal jelzett gomb megnyomásával megnyílik egy ablak az új kategória szerkesztésére.",
  inicio20:
    "5. lépés: A következő képernyőn a ⬆️ nyíllal jelzett gomb megnyomásával törölheti a kategóriát.",
  inicio21:
    "1. lépés: Nyomja meg az alábbi gombot egy új kihívás hozzáadásához a kategóriához.",
  inicio22: "Új kihívás létrehozása",
  inicio23:
    "2. lépés: Kattintson az egyes bekarikázott elemekre, hogy részletesen megismerje a nyilvántartás egyes mezőit.",
  inicio24: "A kihívás szövege",
  inicio25: `Írd meg a kihívást tetszésed szerint, és ahhoz, hogy a játékos neve megjelenjen a kihívásban, egyszerűen nyomd meg az alábbi piros gombot. 
    
A következő karaktereket adja hozzá {név}. 

** NE VÁLTOZZA MEG EZEKET A JELEKET ** Mert ahhoz, hogy a név megfelelően jelenjen meg, az alábbiakban leírtak szerint kell lennie. ⬇️⬇️⬇️⬇️

Kihívás: Csókold meg a nyakát {nome}`,
  inicio26: "Ki tehet, és ki kaphat",
  inicio27: `Válassza a "Mindkettő" lehetőséget, ha a kihívást "mindkét" nemű résztvevő teljesítheti és fogadhatja.
  
Ha a kihívás egy műfajra irányul, csak válassza ki a kívánt műfajt.
`,
  inicio28: "Idő hozzáadása a kihíváshoz",
  inicio29:
    'Ha a kihívásodnak van ideje, egyszerűen húzd a "tartományt" alulra, és az érték fent fog megjelenni. Miután a kihívás ideje letelt, egy hangjelzés fogja jelezni, hogy a kihívás véget ért.',
  aviso12: `Itt csak a kategóriát hozza létre!
    
A kihívások hozzáadásához csak nyomja meg az éppen létrehozott kategória gombját ⬆️⬆️⬆️⬆️⬆️⬆️⬆️.`,
  voltar: "Vissza",
  semDe: "Játékos regisztrált kihívások nélkül",
  semDe2: `Regisztráljon legalább egy kihívást ennek a játékosnak 😬. 
  
A rendszer átirányítja Önt a bejelentkezési képernyőre.`,
  term: "Adatvédelem",
  Potitic: "Felhasználási feltételek",
  adquirited: "Megszerzett",
  camera: "Kamera",
  galery: "Galéria",
  avatar: "Avatar",
  image: "Kép",
  seletion: " Kiválasztott",
  editCategory: "A kategória szerkesztése",
  frase1: "Élvezed a kihívásokat?",
  frase2: "Mit szólnál a Prémium Kihívások kipróbálásához?",
  //err texto

  errTexto:
    "Ha fordítási hibát talált, kérjük, javítsa ki a mondatot az alábbi mezőben:",
  errTitulo: "Észrevettél valami hibát?",
  errCorrect: "Hogyan lenne magyarul?",
  thisLanguageIsCorrect: "A KIHÍVÁS MAGYARUL helyes?",
  yes: "Igen",
  no: "Nem",

  share: "Megosztás",
  fraseShare: `Micsoda Top app! Csak azért osztom meg, mert tudom, hogy neked is tetszeni fog!🫣
Töltsd le, aztán mondd meg, ha nem túl jó lol...😉
  
  
Link a letöltéshez: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇭🇺",

  morePlayer: "Több játékossal játszani ?",
  players: "játékosok",
  carregar: "Kép feltöltése",
  takePhoto: "Készítsen képet vagy válasszon ki egy képet",
  useAvatar: "Vagy használjon avatárokat",

  hetero: "Hetero pár",
  gay: "Meleg pár",
  lesbico: "Leszbikus pár",

  nomeHomem1: "James",
  nomeHomem2: "George",
  nomeMulher1: "Emily",
  nomeMulher2: "Mia",
  messageErr: "Add hozzá a játékosokat 🙌",
  descricaoErr: "Adja meg a résztvevők nevét ✍️",
  why: "Mondja el, miért...",
  later: "Később értékelje ki",

  txtCard1: "Te jössz 🔥",
  txtCard2: "Make it happen 😘",
  txtCard3: "Come on! 😜",
  txtCard4: "Következő kihívás 😈",
  txtCard5: "Még egy! 👄",

  tituloBloco1Novo: "Fedezd fel a szexuális intimitást a partnereddel",
  subtitulo1Novo: "Több mint 1 millió boldog pár",
  texto1Novo:
    "Fedezd fel az intimitást közted és a partnered között, és férj hozzá a legjobb páros játékokhoz! Oldd fel most az összes játékot, több kategóriában, amelyek a kapcsolatotok javítását szolgálják a szerelmeddel",

  tituloBloco2Novo: "Új élmények és jobb kapcsolat",
  texto2Novo1: "Élvezd a több mint 1500 kihívást",
  texto2Novo2: "Hozz létre saját kihívásokat",
  texto2Novo3: "Kizárólagos kategóriák",
  texto2Novo4: "Nincsenek hirdetések",
  texto2Novo5: "Kizárólagos avatárok",
  texto2Novo6: "Minden nap új kihívások",
  texto2Novo7: "Rendszeresen frissített játékok",
  tituloBloco3Novo: "A legmagasabb minősítés kategóriában",
  tituloBloco4Novo: "Előnyök a kapcsolatod számára:",
  texto4Novo1: "Intimitás",
  texto4Novo2: "vágy",
  texto4Novo3: "könnyedség",
  texto4Novo4: "vonzalom",
  texto4Novo5: "kapcsolat",
  texto4Novo6: "öröm",

  tituloBloco5Novo: "Mit mondanak a párok",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Szerintem ez a legjobb alkalmazás, amit eddig mobilon találtam: erotikus és érdekes. Az összes többi app, amit láttam, nem ér fel ezzel, szóval szerezz munkát és vedd meg. Ne panaszkodj, hogy nincs pénzed. Nagyszerű dolgokról maradsz le, és mindössze 10 dollárért a teljes alkalmazás a tiéd lehet. Jobb élményeket nyújt, mint a helyi szexboltokban kapható játékok.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Ez az alkalmazás fantasztikus! Először kételkedtem, hogy letöltsem-e, de ez volt a legjobb érzés, amit az utóbbi időben átéltünk. Olyan jó tudni, hogy még mindig rengeteg dolgot tudunk együtt csinálni. 🤭 Kipróbáltuk a fizetős verziót, és tényleg megéri, még sosem értünk el ilyen szintű élvezetet.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Ha szeretnéd feldobni a kapcsolatotokat, ez az app tökéletes! Már más alkalmazásokat is kipróbáltam, de egyik sem tetszett annyira, mint ez. Az előjátékunk sokkal forróbb és élvezetesebb volt (képzeld el a folytatást!). Tényleg megéri megvenni a fizetős verziót (ha intenzívebb élményre vágysz), de az ingyenes verzió is meglepően jó volt.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Kiváló! Tényleg nagyon jó... A játék alatt annyira beindultunk, hogy a szex sokkal izgalmasabb lett, mindenhol csak az élvezet volt! Már alig várjuk, hogy újra játsszunk 💦🔥. A fizetős verziót is ajánljuk, ha bírjátok az izgalmat 🤤.",
  tituloBloco6Novo:
    "Csináld, mint több száz pár szerte a világon, és fűszerezd meg a kapcsolatodat. Fedezz fel több mint 800 új kihívást!",
  texto6Select: "Válassza ki a verziót:",
  texto6Premium: "Premium",
  texto6Assinatura: "előfizetés",
  texto6Mensal: "Havi ",
  texto6Anual: "Éves ",
  texto6Vitalicia: "Élethosszig tartó licenc",
  bePremium: "Legyen Prémium",
  buyNew: "Vásárolj",
  attention: "Figyelem!",
  changeGender: "Megváltozott a szexuális irányultságod.",

  tituloAvaliacao: "Tetszik a játék?",
  textoAvaliacao: "Értékelje és segítsen nekünk továbbfejleszteni!",
  agoraNão: "Most nem",
  enviarAvaliacao: "Küldés",

  nomeJogo1: "Pikáns kihívások",
  nomeJogo2: "Felelsz vagy Mersz?",
  nomeJogo3: "Kacérság Szintje",
  nomeJogo4: "Pajkos Rulett",
  nomeJogo5: "A nap mondása",
  naughtyQuiz: "Tréfás kvíz",

  playAlone: "Egyedül játszani",
  estaSozinho: "Egyedül vagy?",
  selectPlayer: "Játékos kiválasztása",

  skip: "Átugrani",
  responder: "Küldés",
  respondaAqui: "Válaszolj itt",
  config4: "Válassz testreszabható avatárokat",

  tituloSelect1: "Egyedül játszik?",
  tituloSelect2: "Válaszoljon kínos kérdésekre!",

  subTituloSelect1: "Segítünk egy kicsit!",
  subTituloSelect2: "Fedezze fel, mennyire csintalan vagy!",
  txtJogador1:
    "Válaszd ki a játékosod, és fedezd fel a kifejezetten neked tervezett irányított solo élvezeteket!",
  txtJogador2: "A kiválasztott játékos válaszol a kérdésekre",
  tituloCena: "MELYIK TÉTELEKET SZERETNÉ HASZNÁLNI?",
  subTituloCena: `Nincs néhány? Érintse meg az "Szerzés" gombot és vásárolja meg a partnertárcaban`,
  play: "Játszani",

  titleUserWarning: "Válasszon egy felhasználót",
  txtUserWarning: "Válasszon egy felhasználót a kérdések megválaszolásához",
  shareNivelDeSafadeza:
    "Hé, nézd meg a csintalanság szintemet 😈 Tapasztalj intenzív élvezeti pillanatokat. Te is 💋 Töltsd le az alkalmazást most, és készülj a forró kihívások 🔥 élvezetére a partnereddel: ➡️ https://izgatókihívásokapp.page.link/sharelevelhot",

  shareDica:
    "Változtasd meg most a szerelmi életedet! Töltsd le az alkalmazást, és fedezd fel a pikáns kapcsolat titkát: ➡️ https://izgatókihívásokapp.page.link/tipoftheday",

  resultadoQuiz1:
    "Te egy visszafogott ember vagy, nem igazán érdekel a huncutság, inkább a romantikát kedveled!",
  resultadoQuiz2:
    "Túlságosan romantikus vagy ahhoz, hogy huncutkodj, és inkább a gyertyafény hangulatát részesíted előnyben.",
  resultadoQuiz3:
    "Eléggé visszafogott személy vagy, és hiszel abban, hogy az intim dolgokat diszkréten és magának kell tartani.",
  resultadoQuiz4:
    "Ez nem azt jelenti, hogy néha ne volnál vad, de inkább a különleges valakivel szeretnéd megosztani ezt a tüzet.",
  resultadoQuiz5:
    "A hevességed háttérbe szorul, de ez nem változtat azon a tényen, hogy hevesség van benned!",
  resultadoQuiz6:
    "Szeretsz új élményeket felfedezni, de mindig tisztelettel és beleegyezéssel.",
  resultadoQuiz7:
    "Imádsz forró találkákat, tele csókkal és szenvedéllyel. Ugyanakkor van egy olyan oldalad is, amelyik élvezi egy filmet nézni a pároddal kéz a kézben vagy egy gyertyafényes vacsorát.",
  resultadoQuiz8:
    "Készen állsz arra, hogy új és izgalmas dolgokat próbálj ki, de mindig felelősségteljesen.",
  resultadoQuiz9:
    "Bátor személy vagy, és időnként fűszerezni szereted az intim dolgokat.",
  resultadoQuiz10:
    "Szeretsz élvezni az élet minden örömét, és nincs határ, amikor a szexről van szó.",
  resultadoQuiz11:
    "Veled nincs rossz idő, és mindig jó egy gyors kis együttlétnek! Romantikus film? Csak akkor, ha az Ötven árnyalata!",
  resultadoQuiz12:
    "Számodra az intimitás egy állandó kaland, és nincs félelem a kockázatvállalástól.",
  mes: "Hónap",
  desafiosRestantesDois: "2 Premium kihívásod van még!",
  nenhumDesafioRestante: "Nincs több Premium kihívás!",
  tornePremiumAviso1:
    "Legyél most prémium és élvezd az 1000 Exkluzív kihívást!",
  tornePremiumAviso2:
    "Élvezd a korlátlan kihívásokat, exkluzív tartalmakat és megszakítás nélküli szórakozást!",
  conteudoPremium: "Választottál Prémium tartalmat!",
  aproveite4desafios:
    "Élvezd az 4 exkluzív kihívást a kizárólagos élvezet kipróbálásához.",
  calculando: "Eredmények kiszámítása...",
  nivelRomantismo: "A romantikai szinted...",
  finalizar: "Befejezés",
  erroQuizTitulo: "Adja meg a válaszát",
  erroQuizFrase: "A folytatáshoz adja meg a válaszát!",
  new: "Új alkalmazás",

  //resposta quiz safadeza
  resQuiz1: "Gyengéd",
  resQuiz2: "Szenvedélyes",
  resQuiz3: "Bűbájos",
  resQuiz4: "Szuper csintalan",

  texto6Semanal: "Heti",
  weekly: "Heti Aláírás",

  tempSemanal: "Hetente elszámolva",
  tempMensal: "Havonta elszámolva",
  tempAnual: "Évente elszámolva",
  tempSempre: "Egyszeri fizetés",
  canceleAny: "Bármikor lemondható",

  //Tela do safadrometro
  Low: "Alacsony",
  Medium: "Közepes",
  High: "Magas",

  lifeTime: "Élethosszig tartó hozzáférés",
  notNow: "Most nem, kösz.",
  match: "PÁROSÍTÁS A.I-VAL",

  //Modal date
  dateTitle: "Szeretnéd kipróbálni az új alkalmazásunkat?",

  dateBody: `Szeretnél beszélgetni csintalan 😈 botokkal és gyakorolni a flörtölést? Jó szórakozás lesz! 🔥`,
  goToDate: "Próbáld ki a Date.AI-t most!",
  goodForU: "JÓ VOLT NEKED?",
  rateOurPerformance: "Értékelje eddigi teljesítményünket",
  veryGood: "Nagyon jó",
  veryBad: "Nagyon rossz",
  feedbackChallenge: `Mi késztetne arra, hogy megoszd a Forró Kihívások alkalmazást más párokkal és miért?`,
  type: "Írd be a válaszod ide...",
  survey: "Elégedettségi felmérés.",
  shareIfConfortable: `Nyugodtan oszd meg a barátaiddal, ha jól érzed magad :)`,

  howToPlay: "Hogyan kell játszani",
  howToPlayHotChallenge:
    "Készülj, hogy felpezsdítsd a dolgokat! Húzz egy kihíváskártyát, és lepd meg a partnered forró akcióval!",

  preGameTip1:
    "Engedd szabadjára vágyaidat, és teremts felejthetetlen pillanatokat a pároddal!",
  preGameTip2:
    "Lobbantsd lángra a szenvedélyed, és teremts felejthetetlen pillanatokat együtt!",
  preGameTip3:
    "Fedezd fel legvadabb vágyaidat, és alkoss felejthetetlen emlékeket!",
  preGameTip4:
    "Engedd szabadjára a fantáziáidat, és élvezd a tiszta gyönyör pillanatait!",
  selecionajoagador: "Itt az ideje játszani",
  dica: "Tipp",

  howToPlayNaughty:
    "Válaszd ki a kedvenc játékaidat és tárgyaidat. Pörgesd meg a kereket, és hagyd, hogy a sors döntse el a következő pajzán kihívásod!",
  howToPlayTruthOrDare:
    "Válaszd a sorsodat: oszd meg az igazságot, vagy vállalj egy merész kihívást. Kezdődjön a szórakozás!",
  howToKama1: "Fedezd Fel az Öröm Pozícióit – 365 Nap Szenvedély!",
  howToKama2:
    "Húzz egy véletlenszerű kártyát, próbáld ki a pozíciót, és fedezzetek fel együtt új örömöket!",
  kamaExplain:
    "Nyiss meg minden nap egy új pozíciót, és építsd fel a szenvedély végső gyűjteményét – a 365 napos felejthetetlen élvezet útja itt kezdődik!",
  howToDo: "Hogyan kell csinálni",
  pergunta: "Kérdés",
  restart: "Újraindítás",
  dialogText1HotChallenges:
    "Teljesítetted az összes elérhető kihívást a kiválasztott kategóriákkal.",
  dialogText2HotChallenges:
    "Válassz további kategóriákat, vagy indítsd újra a játékot a jelenlegi kihívásokkal!",
  noChallenges: "Nincsenek kihívások!",

  objects: "Objektumok",
  dialogText1NaughtyGames:
    "Teljesítetted az összes elérhető kihívást a kiválasztott objektumokkal.",
  dialogText2NaughtyGames:
    "Válassz több objektumot, vagy indítsd újra a játékot az aktuális kihívásokkal!",
  unlockPremium: "Premium Feloldása",
  noCategory: "Kérjük, válasszon legalább egy kategóriát a kezdéshez.",
  thanksForFeedback: "Köszönjük, hogy segít nekünk a tapasztalat javításában!",
  categoryKamasutra: "Válaszd ki a szenvedélyed, és játssz!",
  tap: "Koppints, hogy felfedd a pozíciódat!",
  step: "Lépésről Lépésre Útmutató",
  shareQuizButton: "Oszd meg a pajkos szintedet!",
  tryAgain: "Próbáld újra",
  unlockAllFun: "Oldd fel az összes szórakozást",
  limitedOffer: "Különleges ajánlat korlátozott ideig!",
  fill: "Írja be a saját és partnere nevét.",

  kamaNotificationTitle: "🔥 Az új kártyád feloldva!",
  kamaNotificationBody:
    "A(z) {variavel}. napi pozíciód készen áll. Mit szólnál, ha ma kipróbálnál valami újat? 💋",

  titleNewGame: "Készülj a Szerepjátékra!",
  phraseNewGame:
    "A következő frissítéssel egy új játék érkezik, amely segít felfedezni legkreatívabb fantáziáidat. Válassz karaktereket, alkoss történeteket, és emeld a szórakozást új szintre a partnereddel. 🔥",
  awaitNewGame: "Várj türelemmel, és készülj fel az egyedi pillanatokra!",

  selectObjects:
    "Válassz ki kettő vagy több elemet a játék személyre szabásához. Fedezd fel a maximumot!",
  soon: "Hamarosan",
  wantToBeNotify: "Értesítést szeretnék kapni.",
  ok: "OK",
  vezDe: "FORDULJ",

  categoryLabel: "Kategória",
  descriptionLabel: "Leírás",

  loginConnect: "Bejelentkezés",
  loginNoAccount: "Nincs fiókja?",
  loginCreateNow: "Hozza létre most",
  loginOrConnect: "vagy csatlakozzon",

  email: "Email",
  password: "Jelszó",
  loginRegister: "Regisztráció",
  loginAlreadyHas: "Már van fiókja?",
  enterNow: "Lépjen be most",

  logout: "Kijelentkezés",
  customerPortal: "Ügyfélportál",
  installApp: "Telepítse az alkalmazást",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/hungaro.mp4",
};
